module.exports = __webpack_public_path__ + "0b91800db08621e10138d12043a05bac.svg";